<!-- 采购单模板 -->
<template>
	<el-dialog  title="选择采购单"  :visible.sync="dialogVisible"  width="90%" append-to-body top="1rem" center>
		<subComponents  ref="showSelectData"></subComponents>
		<div class='components_content_box'>
			<div class="components_content_top">
				<el-form :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData[0]">
					<el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in pageShowData[0].jurconfigform" :key="formOneKey">
						<el-input  v-model.trim="getRequestData[formOneValue.entityField]" size="mini" :maxlength="$store.state.inputLength"></el-input>
					</el-form-item>
				
					<el-form-item>
						<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
					</el-form-item>
					
				</el-form>
			</div>
			<div class="components_content_content">
				<el-table v-if="pageShowData[1]" stripe :data="returnData.list" height="100%"  border  style="width: 100%" highlight-current-row>
					<el-table-column type="expand" label="其它" width="70">
					    <template slot-scope="props">
							<el-tabs type="border-card">
								
								<el-tab-pane label="采购订单明细">
									<div style="margin-bottom: .5rem;">
										<el-button @click="selectDataAction" size="mini">确定选择</el-button>
									</div>
									<el-table v-if="pageShowData[2]" :data="props.row.pisOrderDetail"  @selection-change="selecDetailsDataAction"  border  style="width: 100%">
										<el-table-column type="selection" width="55">
										</el-table-column>
										<el-table-column
											v-if="tableValye.isShow==1" 
											v-for="(tableValye,tableKey) in pageShowData[2].jurconfigtable" 
											:key="tableKey" 
											:prop="tableValye.entityField"  
											:label="tableValye.showField"  >
											<template  slot-scope="scope">
												<div v-if="tableValye.entityField == 'psodState'">
													{{$store.state.purchaseOrderDetailsState[scope.row.psodState].name}}
												</div>
												<div v-else>
													{{scope.row[tableValye.entityField]}}
												</div>
											</template>
										</el-table-column>
									</el-table>
								</el-tab-pane>
								
								<el-tab-pane label="采购订单辅助信息">
									<el-table v-if="pageShowData[3]" :data="[props.row.pisOrderAuxinf]" height="100%"  border style="width: 100%">
										<el-table-column
											v-if="tableValye.isShow==1" 
											v-for="(tableValye,tableKey) in pageShowData[3].jurconfigtable" 
											:key="tableKey" 
											:prop="tableValye.entityField"  
											:label="tableValye.showField"  >
											<template  slot-scope="scope">
												<div v-if="tableValye.entityField == 'psaiDeptime'">
													{{$common.getLocalTime(scope.row[tableValye.entityField])}}
												</div>
												<div v-else-if="tableValye.entityField == 'psaiExptime'">
													{{$common.getLocalTime(scope.row[tableValye.entityField])}}
												</div>
												<div v-else>
													{{scope.row[tableValye.entityField]}}
												</div>
											</template>
										</el-table-column>
									</el-table>
								</el-tab-pane>
							</el-tabs>
					    </template>
					</el-table-column>
					<el-table-column
						v-if="tableValye.isShow==1"
						v-for="(tableValye,tableKey) in pageShowData[1].jurconfigtable" 
						:key="tableKey" 
						:prop="tableValye.entityField"  
						:label="tableValye.showField">
						<template  slot-scope="scope">
							<div v-if="tableValye.entityField == 'psomState'">
								{{$store.state.purchaseOrderState[scope.row[tableValye.entityField]].name}}
							</div>
							<div v-else-if="tableValye.entityField == 'psomIswmsm'">
								{{scope.row.psomIswmsm == 0 ? '否' : '是'}}
							</div>
							<div v-else-if="tableValye.entityField == 'psomBuydate'">
								{{$common.getLocalTime(scope.row.psomBuydate)}}
							</div>
							
							<div v-else>
								{{scope.row[tableValye.entityField]}}
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="components_content_bottom">
				<el-pagination
					background
					@size-change="setDataPageSize"
					@current-change="setDataPageNumber"
					:current-page="getRequestData.page"
					:page-sizes="[30,50,100,500]"
					:page-size="30"
					layout="total, sizes, prev, pager, next, jumper"
					:total="returnData.total">
				</el-pagination>
			</div>
		</div>
	</el-dialog>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	name:'procurementOrderTemplate',
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		//这里存放数据
		return {
			dialogVisible:false,
			getRequestData:{
				bgmName:'',
				bgmActivestatus:'',
				page:1,
				rows:30,
				start:'',
				end:'',
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
			pageShowData:[],
			formDataList:[],
			selectedDataIndex:[],
			selectedDetailsDataIndex:[],
			selectFile:[],
			
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
	},
	//方法集合
	methods: {
		openBox(){
			this.getPageInfo()
			this.getDataList()
			this.dialogVisible = true
		},
		
		selecDetailsDataAction(data){
			this.selectedDetailsDataIndex = []
			console.log(data)
			data.forEach(item=>{
				this.selectedDetailsDataIndex.push(item.psodId)
			})
			
			console.log(this.selectedDetailsDataIndex)
	
		},
		
		selectDataAction(row){
			// var  dataInfo = this.returnData.list[this.selectedDataIndex]
			// if(!dataInfo){
			// 	this.$message({
			// 		message: '请先选中要操作的数据',
			// 		type: 'error'
			// 	});
			// 	return false
			// }
			if(this.selectedDetailsDataIndex.length<1){
				this.$message({
					message: '请先选中要操作的明细',
					type: 'error'
				});
				return false
			}
			// var  dataInfo = this.returnData.list[this.selectedDataIndex].pisOrderDetail[selectInfo[1]]
			row = this.selectedDetailsDataIndex
			this.$emit('selectDataAction',row);
			this.dialogVisible = false
			// var dataOne = this.selectedDataList[0]
			// var saveData = []
			// this.selectDetails.forEach((item,keys)=>{
			// 	if(item.psomId == dataOne.psomId){
			// 		console.log(item)
			// 		saveData.push(item.psodId)
			// 	}
			// })
			
			// console.log(saveData)
			// sessionStorage.setItem('selectProcurmentOrderDetails',saveData)
			// this.dialogVisible = false
			// this.$parent.procurementOrderExtract()
			// this.$emit('selectDataAction',row);
		},
		// 获取数据列表
		async getPageInfo(){
			var pathId = parent.getMenuInfo('/purchaseOrderList')
			let responseData =  await this.$http.pageFormText({ids:[pathId.jurId]})
			if(responseData.status == 200){
				this.pageShowData = responseData.result
			
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		selecDataAction(data){
			this.selectedDataList =  data
		},
		selectDetailsction(data){
			this.selectDetails =  data
			console.log(data)
		},
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		
		
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.getNotExtractPurchaseOrder(this.getRequestData)
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
				this.selectedDataIndex = 0
				this.selectedDetailsDataIndex = []
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.table_content_tag{
	margin-right: 1rem;
}
.el-tabs--border-card_new{
	height: 85vh;
	overflow-y: scroll;
}
</style>
